import { Col, Flex, Row, theme } from 'antd';
import { FC, memo } from 'react';

import { AppBreadcrumb } from '@/modules/AppBreadcrumb';
import { UserSiderSection } from '@/modules/Users';
import { TeamProfileDropdown } from '@/modules/Users/views/TeamProfileDropdown';

export const CommonLayoutHeader: FC = memo(() => {
  const { token } = theme.useToken();

  return (
    <div
      className="common-layout__header"
      style={{
        borderBottom: `1px solid ${token.colorBorder}`,
        backgroundColor: token.colorBgContainer,
      }}
    >
      <Row justify="space-between" align="middle">
        <Col span={6}>
          <Flex align="center" gap={16}>
            <UserSiderSection />
            <TeamProfileDropdown />
          </Flex>
        </Col>

        <Col>
          <AppBreadcrumb />
        </Col>

        <Col span={6}>
          <div style={{ width: 30, height: 30 }}></div>
        </Col>
      </Row>
    </div>
  );
});
